import { createContext, useContext, useEffect, useState } from 'react';

/** <1024px = mobil chrome (drawer + hamburger). Tailwind `lg` ile hizalı. */
export const DG_MOBILE_QUERY = '(max-width: 1023px)';

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(DG_MOBILE_QUERY).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(DG_MOBILE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}

export interface PanelChromeState {
  isMobile: boolean;
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
}

/**
 * Defaults = desktop davranışı: Sidebar/Topbar PanelFrame dışında render
 * edildiğinde (design-screens) bugünkü gibi çalışır.
 */
const PanelChromeContext = createContext<PanelChromeState>({
  isMobile: false,
  navOpen: false,
  setNavOpen: () => {},
});

export const PanelChromeProvider = PanelChromeContext.Provider;

export function usePanelChrome(): PanelChromeState {
  return useContext(PanelChromeContext);
}
